import React from 'react';
import { ThemeSwitch } from '../../components/shell/ThemeSwitch';
import { Section } from '../../components/ui';

export const AppearanceSection: React.FC = () => (
  <Section title="Darstellung" description="Wähle, wie Schneller Wohnen auf diesem Gerät aussieht.">
    <ThemeSwitch />
  </Section>
);
